import type { CustomCellRendererProps } from "ag-grid-react";
import i18n from "i18next";
import * as R from "ramda";
import React from "react";
import k from "src/i18n/keys";

import { useDispatch } from "react-redux";
import { resendInvite } from "src/actions/user";
import NameOrEmail from "src/components/user/NameOrEmail";
import Picture from "src/components/user/picture";
import type { Nullable } from "src/ts-types";
import type { UID } from "src/types";
import InvitingUser from "../InvitingUser";
import {
  AuthorWrapper,
  ImageLabel,
  UserCellContainer,
  UserInfo,
} from "./styles";

interface UserCellRendererParams extends CustomCellRendererProps {
  data: { uid: UID };
  onUserClick?: (uid: UID) => void;
}

export const UserCellRenderer = ({
  data,
  value: user,
  onUserClick,
}: UserCellRendererParams): Nullable<React.ReactElement> => {
  const dispatch = useDispatch();

  const handleNameClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onUserClick) {
      onUserClick(data.uid);
    }
  };

  const handleResendInvite = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(resendInvite(data.uid));
  };

  if (!user) return null;

  return (
    <UserCellContainer>
      <UserInfo>
        <ImageLabel>
          <Picture user={user} />
        </ImageLabel>
        <AuthorWrapper onClick={handleNameClick}>
          <NameOrEmail user={user} />
        </AuthorWrapper>
        {user.invitePending &&
          user.orgRole !== "contact" &&
          user.orgRole !== "collaborator" && (
            <InvitingUser
              uid={data.uid}
              text={i18n.t(k.RESEND)}
              handleClick={handleResendInvite}
            />
          )}

        {R.includes(user.orgRole, ["collaborator", "contact"]) && (
          <InvitingUser
            uid={data.uid}
            text={i18n.t(k.INVITE1)}
            handleClick={handleResendInvite}
          />
        )}
      </UserInfo>
    </UserCellContainer>
  );
};
